/* Portal de l'autor — Llamps i Trons
   ----------------------------------------------------------------------
   Llegeix UN document públic de Firestore i el pinta. No fa servir cap
   llibreria externa a posta: només `fetch` contra l'API REST de Firestore.
   (En aquest projecte ja hem tingut una dependència per CDN que va fallar
   en silenci, i aquí costaria molt de diagnosticar.)

   L'adreça porta ?a=<codi>. Aquest codi és un aleatori de 128 bits que
   fa de clau: les regles de seguretat deixen llegir el document que li
   correspon, però NO deixen llistar la col·lecció, així que tenir un codi
   no serveix per trobar els altres.
   ---------------------------------------------------------------------- */
(function () {
  var arrel = document.querySelector('[data-lit-portal]');
  if (!arrel) return;

  var PROJECTE = arrel.getAttribute('data-projecte');
  var CLAU_API = arrel.getAttribute('data-clau');
  var CONTACTE = arrel.getAttribute('data-contacte') || '';
  var LOGOTIP = arrel.getAttribute('data-logotip') || '';

  var MESOS = ['gener', 'febrer', 'març', 'abril', 'maig', 'juny', 'juliol', 'agost', 'setembre', 'octubre', 'novembre', 'desembre'];

  /* El llamp del logotip oficial de Llamps i Trons. Va inline perquè es pinti
     amb `currentColor` i no calgui carregar cap imatge. */
  var LLAMP = 'M263.99,184.62c19.68,11.6,27.4,35.71,21.64,56.99-2.22,8.6-6.23,16.19-12.64,22.61-2.73,2.74-5.4,5.54-7.89,8.5-7.53,8.94-22.5,22.18-36.32,32.53-12.51,9.37-24.4,19.54-35.67,30.37-8.99,8.64-18.23,17.25-27.46,25.37-3.02,2.66-6.21,5.12-9.56,7.34-19.02,12.61-37.21,28.27-50.87,44.25-42.77,39.52-72.78,29.32-55.62-23.93,98.61-187.71-77.3-7.34-45.76-174.74,10.98-46.01,21.14-82.8,31.77-127.55,1.5-6.32,2.59-12.73,3.27-19.19C42.93,28.73,46.34-2.9,99.55,1.91c29.78,2.37,140.66-13.59,142.44,18.54,5.45,21.88-10.95,44.3-17.44,65.1-7.69,21.23-16.83,42-26.41,62.35-20.84,47.75,46.36,20.38,65.86,36.72ZM150.48,207.46c12.77-28.94,25.18-59.18,36.39-88.91,4.5-21.85,12.2-41.38,23.49-60.38,13.61-32.09-1.94-30.59-34.65-31.24-10.61-.58-26.98-1.74-38.8-.85-64.56,4.85-61.13-15.18-73.79,42.9-12.15,59.83-30.34,121.92-39.42,182.41-.73,4.84.79,9.8,4.3,13.21,16.15,15.71,57.68,4.91,77.58,6.12,3.62.22,7.26.18,10.86-.32,7.15-.99,12.58-3.53,15.04-12.34,5.1-16.71,12.81-34.3,18.99-50.6ZM169.76,264.13c9.44-3.52,20.34-19.87,27.02-26.9,19.75-20.29,31.31-40.95-10.27-35.3-8.29,1.57-9.93,12.55-13.02,19.36-2.38,10.71-26.05,43.67-3.72,42.84ZM83.94,378.12c-4.91,33.39,58.37-26.5,90.01-58.34,11.27-11.34,23.47-21.69,36.42-31.07,18.06-13.08,38.32-29.91,48.07-47.23,3.19-5.67,3.73-12.51,1.12-18.47-11.29-25.82-46.34,35.41-60.99,50-2.53,2.53-4.97,5.15-7.4,7.77-15.61,16.78-42.41,15.09-63.27,17.32-28.81,1.01-31.74,49.51-41.21,70.87-1.3,2.93-2.29,5.99-2.75,9.16Z';
  function llamp(classe) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 287.5 436.58');
    s.setAttribute('fill', 'currentColor');
    s.setAttribute('aria-hidden', 'true');
    if (classe) s.setAttribute('class', classe);
    var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', LLAMP);
    s.appendChild(p);
    return s;
  }

  /* Icones de les files (traç, com les del Dashboard). */
  function icona(d) {
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '1.8');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.setAttribute('aria-hidden', 'true');
    d.forEach(function (x) {
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', x);
      s.appendChild(p);
    });
    return s;
  }
  var IC_EURO = ['M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2', 'M4 10h12', 'M4 14h9'];
  var IC_VIST = ['M20 6 9 17l-5-5'];
  var IC_MICRO = ['M12 2.5a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0v-5a3 3 0 0 0-3-3Z', 'M5.5 11a6.5 6.5 0 0 0 13 0', 'M12 17.5V21', 'M8.5 21h7'];
  var IC_DOC = ['M14 3H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V8', 'M14 3l5 5h-5V3Z'];
  var IC_DOSSIER = ['M14 3H6.5A1.5 1.5 0 0 0 5 4.5v15A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V8', 'M14 3l5 5h-5V3Z', 'M9 13h6', 'M9 16.5h4'];

  /* ---------- Utilitats ---------- */

  /* Els textos venen de la base de dades: sempre amb textContent, mai
     enganxant HTML, perquè un títol amb "<" no pugui trencar res. */
  function el(tag, classe, text) {
    var n = document.createElement(tag);
    if (classe) n.className = classe;
    if (text !== undefined && text !== null && text !== '') n.textContent = String(text);
    return n;
  }

  function dataLlarga(iso) {
    if (!iso) return '';
    var t = String(iso).slice(0, 10).split('-');
    if (t.length < 3) return String(iso);
    return parseInt(t[2], 10) + ' de ' + (MESOS[parseInt(t[1], 10) - 1] || '') + ' de ' + t[0];
  }

  function mesLlarg(ym) {
    if (!ym) return '';
    var t = String(ym).split('-');
    if (t.length < 2) return String(ym);
    var m = MESOS[parseInt(t[1], 10) - 1];
    return m ? m.charAt(0).toUpperCase() + m.slice(1) + ' de ' + t[0] : String(ym);
  }

  function euros(n) {
    try { return new Intl.NumberFormat('ca-ES', { style: 'currency', currency: 'EUR' }).format(Number(n) || 0); }
    catch (e) { return (Number(n) || 0).toFixed(2) + ' €'; }
  }

  /* Firestore torna els valors etiquetats amb el seu tipus
     ({"stringValue": "..."}), així que cal desembolicar-los. */
  function valor(v) {
    if (v === null || v === undefined) return null;
    if ('stringValue' in v) return v.stringValue;
    if ('integerValue' in v) return Number(v.integerValue);
    if ('doubleValue' in v) return Number(v.doubleValue);
    if ('booleanValue' in v) return v.booleanValue;
    if ('nullValue' in v) return null;
    if ('timestampValue' in v) return v.timestampValue;
    if ('arrayValue' in v) return (v.arrayValue.values || []).map(valor);
    if ('mapValue' in v) return camps(v.mapValue.fields || {});
    return null;
  }
  function camps(f) {
    var out = {};
    Object.keys(f).forEach(function (k) { out[k] = valor(f[k]); });
    return out;
  }

  function missatge(titol, text) {
    arrel.innerHTML = '';
    arrel.classList.add('lit-p');
    var fons = el('div', 'lit-p__centre');
    var box = el('div', 'lit-p__centre-in');
    box.appendChild(llamp());
    box.appendChild(el('h2', null, titol));
    box.appendChild(el('p', null, text));
    fons.appendChild(box);
    arrel.appendChild(fons);
  }

  /* ---------- Trossos de la pàgina ---------- */

  function fila(icones, titol, subtitol, importText, classe) {
    var f = el('div', 'lit-p__fila' + (classe ? ' ' + classe : ''));
    var ic = el('div', 'lit-p__ico');
    ic.appendChild(icona(icones));
    f.appendChild(ic);
    var in_ = el('div', 'lit-p__fila-in');
    in_.appendChild(el('b', null, titol));
    if (subtitol) in_.appendChild(el('span', null, subtitol));
    f.appendChild(in_);
    if (importText) f.appendChild(el('span', 'lit-p__import', importText));
    return f;
  }

  function seccio(titol, contingut) {
    var s = el('div', 'lit-p__seccio');
    s.appendChild(el('h3', null, titol));
    s.appendChild(contingut);
    return s;
  }

  /* Columna esquerra: en què s'ha convertit la tirada. */
  function blocExemplars(ex) {
    var box = el('div', 'lit-p__exemplars');
    var total = Math.max(1, Number(ex.tirada) || 0);
    var trams = [
      ['venuts', 'Venuts', Number(ex.venuts) || 0, "Exemplars que s'han venut"],
      ['diposit', 'En dipòsit', Number(ex.enDeposit) || 0, 'A les llibreries, pendents de vendre'],
      ['regalats', 'Regalats', Number(ex.regalats) || 0, 'Premsa, promoció i cortesies'],
      ['magatzem', 'Al magatzem', Number(ex.enMagatzem) || 0, 'Encara al nostre magatzem'],
    ];

    var barra = el('div', 'lit-p__barra');
    trams.forEach(function (t) {
      if (t[2] <= 0) return;
      var i = document.createElement('i');
      i.className = t[0];
      i.style.width = (t[2] / total * 100) + '%';
      i.title = t[1] + ': ' + t[2];
      barra.appendChild(i);
    });
    if (barra.childNodes.length) box.appendChild(barra);

    trams.forEach(function (t) {
      var f = el('div', 'lit-p__ex' + (t[0] === 'venuts' ? ' destacat' : ''));
      f.appendChild(el('span', 'lit-p__ex-punt ' + t[0]));
      var nom = el('div', 'lit-p__ex-nom');
      nom.appendChild(el('b', null, t[1]));
      nom.appendChild(el('span', null, t[3]));
      f.appendChild(nom);
      f.appendChild(el('span', 'lit-p__ex-xifra', t[2]));
      box.appendChild(f);
    });

    /* Les edicions, amb la seva data. Si el Dashboard encara no les publica,
       es continua ensenyant el total de sempre. */
    var edicions = (ex.edicions || []).filter(function (e) { return e && (e.exemplars || e.etiqueta); });
    if (edicions.length) {
      var lista = el('ul', 'lit-p__edicions');
      edicions.forEach(function (e) {
        var li = document.createElement('li');
        /* L'ordre importa: la data ocupa tota l'amplada i fa salt de linia, o
           sigui que ha d'anar l'ultima. Si va enmig, empeny els exemplars a una
           tercera linia i queden despenjats de la seva edicio. */
        li.appendChild(el('b', null, e.etiqueta || 'Edició'));
        li.appendChild(el('span', 'lit-p__edicio-xifra', (Number(e.exemplars) || 0) + ' exemplars'));
        if (e.data) li.appendChild(el('span', 'lit-p__edicio-data', dataLlarga(e.data)));
        lista.appendChild(li);
      });
      box.appendChild(lista);
    } else if (ex.tirada) {
      box.appendChild(el('p', 'lit-p__tirada', 'Tirada total: ' + ex.tirada + ' exemplars.'));
    }
    return box;
  }

  /* Columna dreta: drets, presentacions i contracte d'aquest llibre. */
  function blocDetalls(l, presentacions, contractes) {
    var box = el('div', 'lit-p__detalls');

    var d = l.drets || {};
    var drets = document.createElement('div');
    drets.appendChild(fila(IC_EURO, 'Generats', 'Pel total venut fins ara', euros(d.total)));
    drets.appendChild(fila(
      (Number(d.pagat) > 0 ? IC_VIST : IC_EURO),
      'Ja cobrats',
      (Number(d.pagat) > 0 ? 'Liquidat' : 'Encara no hi ha cap liquidació'),
      euros(d.pagat),
      (Number(d.pagat) > 0 ? 'cobrat' : null)
    ));
    drets.appendChild(fila(IC_EURO, 'Pendents', 'Per liquidar', euros(d.pendent), 'pendent'));
    box.appendChild(seccio("Els teus drets d'autor", drets));

    var pres = document.createElement('div');
    if (presentacions.length) {
      presentacions.forEach(function (p) {
        /* Sense els exemplars venuts a la dreta: la xifra per acte no diu gran
           cosa i despistava al costat del total del llibre. */
        pres.appendChild(fila(IC_MICRO, p.lloc,
          dataLlarga(p.data) + (p.hora ? ' · ' + p.hora : '')));
      });
    } else {
      pres.appendChild(el('p', 'lit-p__buit', 'Encara no hi ha cap presentació programada.'));
    }
    box.appendChild(seccio('Presentacions', pres));

    /* Dossier de premsa: el PDF que pot fer servir per moure el llibre. */
    var dossier = (l.dossier || []).filter(function (d) { return d && d.url; });
    var caixaDos = document.createElement('div');
    if (dossier.length) {
      dossier.forEach(function (d) {
        var f = fila(IC_DOSSIER, 'Dossier de premsa', d.nom || '');
        var a = el('a', 'lit-p__btn', 'Descarregar');
        a.href = d.url;
        a.setAttribute('download', d.nom || 'dossier-de-premsa.pdf');
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        f.appendChild(a);
        caixaDos.appendChild(f);
      });
    }
    if (dossier.length) box.appendChild(seccio('Dossier de premsa', caixaDos));

    var cons = document.createElement('div');
    if (contractes.length) {
      contractes.forEach(function (c) {
        var f = fila(IC_DOC, c.nom || 'Contracte signat', c.data ? dataLlarga(c.data) : '');
        var a = el('a', 'lit-p__btn', 'Veure');
        a.href = c.url; a.target = '_blank'; a.rel = 'noopener noreferrer';
        f.appendChild(a);
        cons.appendChild(f);
      });
    } else {
      cons.appendChild(el('p', 'lit-p__buit', 'El contracte signat apareixerà aquí quan estigui disponible.'));
    }
    box.appendChild(seccio('Contracte', cons));

    return box;
  }

  function blocLlibre(l, presentacions, contractes) {
    var card = el('article', 'lit-p__llibre');

    var cap = el('div', 'lit-p__cap');
    var buida = el('div', 'lit-p__portada');
    if (l.portada) {
      var img = document.createElement('img');
      img.className = 'lit-p__portada';
      img.src = l.portada;
      img.alt = 'Portada de ' + (l.titol || '');
      img.loading = 'lazy';
      /* Si la imatge no carrega, el requadre buit ocupa el seu lloc. */
      img.onerror = function () { if (img.parentNode) img.parentNode.replaceChild(buida, img); };
      cap.appendChild(img);
    } else {
      cap.appendChild(buida);
    }

    var capIn = el('div', 'lit-p__cap-in');
    capIn.appendChild(el('h2', null, l.titol));
    /* Gènere i data van en dues pastilles separades, no en una de sola: són
       dues coses diferents i, juntes, en un mòbil la pastilla saltava de línia
       i el punt quedava despenjat al mig. */
    var etiquetes = el('div', 'lit-p__etiquetes');
    if (l.genere) etiquetes.appendChild(el('span', 'lit-p__etiqueta', l.genere));
    var mes = mesLlarg(l.publicacio);
    if (mes) etiquetes.appendChild(el('span', 'lit-p__etiqueta lit-p__etiqueta--data', mes));
    if (etiquetes.childNodes.length) capIn.appendChild(etiquetes);

    var fitxa = el('dl', 'lit-p__fitxa');
    [['Mida', l.mida], ['Enquadernació', l.enquadernacio], ['Pàgines', l.pagines || ''],
     ['ISBN', l.isbn], ['PVP', l.pvp ? euros(l.pvp) : '']].forEach(function (x) {
      if (!x[1]) return;
      var d = document.createElement('div');
      d.appendChild(el('dt', null, x[0]));
      d.appendChild(el('dd', null, x[1]));
      fitxa.appendChild(d);
    });
    cap.appendChild(capIn);
    /* La fitxa tècnica penja de `cap`, no de `cap-in`: així al mòbil pot ocupar
       tota l'amplada de la targeta per sota de la portada. Abans compartia el
       poc espai que queda al costat de la portada i valors com "Tapa tova amb
       solapes" es partien deixant una paraula sola en una línia. */
    if (fitxa.childNodes.length) cap.appendChild(fitxa);
    card.appendChild(cap);

    var graella = el('div', 'lit-p__graella');
    graella.appendChild(blocExemplars(l.exemplars || {}));
    graella.appendChild(blocDetalls(l, presentacions, contractes));
    card.appendChild(graella);

    return card;
  }

  /* ---------- Pintar-ho tot ---------- */
  function pintar(d) {
    arrel.innerHTML = '';
    arrel.classList.add('lit-p');
    var autor = d.autor || {};

    var top = el('div', 'lit-p__top');
    var dins = el('div', 'lit-p__in');

    var salut = el('div', 'lit-p__salut');
    if (autor.foto) {
      var f = document.createElement('img');
      f.className = 'lit-p__foto'; f.src = autor.foto; f.alt = '';
      var inicial = el('div', 'lit-p__inicial', (autor.nom || '?').charAt(0).toUpperCase());
      f.onerror = function () { if (f.parentNode) f.parentNode.replaceChild(inicial, f); };
      salut.appendChild(f);
    } else {
      salut.appendChild(el('div', 'lit-p__inicial', (autor.nom || '?').charAt(0).toUpperCase()));
    }
    var txt = el('div', 'lit-p__salut-txt');
    txt.appendChild(el('h1', null, 'Hola, ' + (autor.nom || '').split(' ')[0]));
    txt.appendChild(el('p', null, 'Dades actualitzades el ' + dataLlarga(d.actualitzat)));
    salut.appendChild(txt);

    /* Logotip a la dreta de la franja, a l'alçada de la foto. Va dins de
       .lit-p__salut perquè s'alineï amb la vora dreta de la columna i no
       amb la de la pantalla. */
    if (LOGOTIP) {
      var lg = document.createElement('img');
      lg.className = 'lit-p__logotip';
      lg.src = LOGOTIP;
      lg.alt = 'Llamps i Trons';
      /* Si no carregués, val més no deixar el forat. */
      lg.onerror = function () { if (lg.parentNode) lg.parentNode.removeChild(lg); };
      salut.appendChild(lg);
    }

    dins.appendChild(salut);
    top.appendChild(dins);
    arrel.appendChild(top);

    var cos = el('div', 'lit-p__cos');
    var llibres = d.llibres || [];
    var totesPres = d.presentacions || [];
    var totsCon = (d.contractes || []).filter(function (c) { return c && c.url; });

    if (llibres.length) {
      llibres.forEach(function (l) {
        var sevesPres = totesPres.filter(function (p) { return p.llibreId === l.id; });
        var seusCon = totsCon.filter(function (c) { return c.llibreId === l.id; });
        cos.appendChild(blocLlibre(l, sevesPres, seusCon));
      });
    } else {
      var buit = el('div', 'lit-p__llibre');
      buit.appendChild(seccio('Els teus llibres', el('p', 'lit-p__buit', 'Encara no hi ha cap llibre publicat.')));
      cos.appendChild(buit);
    }

    var peu = el('div', 'lit-p__peu');
    peu.appendChild(el('p', null, 'Si hi veus res que no quadri o tens qualsevol dubte, escriu-nos' + (CONTACTE ? ' a ' + CONTACTE : '') + '.'));
    cos.appendChild(peu);
    arrel.appendChild(cos);
  }

  /* ---------- Arrencada ---------- */
  var codi = null;
  try { codi = new URLSearchParams(window.location.search).get('a'); } catch (e) {}

  if (!codi || !/^[a-f0-9]{16,64}$/i.test(codi)) {
    missatge('Aquesta pàgina necessita un enllaç personal',
      "Fes servir l'enllaç complet que t'hem enviat. Si l'has perdut, demana'ns-en un de nou.");
    return;
  }

  var url = 'https://firestore.googleapis.com/v1/projects/' + PROJECTE
    + '/databases/(default)/documents/portalAutor/' + encodeURIComponent(codi)
    + '?key=' + encodeURIComponent(CLAU_API);

  fetch(url, { cache: 'no-store' })
    .then(function (r) {
      if (r.status === 404 || r.status === 403) return null;
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function (j) {
      if (!j || !j.fields) {
        missatge('Aquest enllaç no és vàlid',
          "Comprova que l'has copiat sencer. Si el problema continua, escriu-nos i te'n donem un de nou.");
        return;
      }
      pintar(camps(j.fields));
    })
    .catch(function () {
      missatge('Ara mateix no hem pogut carregar les dades',
        'Torna-ho a provar d’aquí a una estona. Si segueix igual, escriu-nos.');
    });
})();
